// extracted by mini-css-extract-plugin
export default {"component":"Reviews__component-yS9j","headingWrapper":"Reviews__headingWrapper-gI8k","trustpilot":"Reviews__trustpilot-BItw"};